module.exports = __webpack_public_path__ + "media/images/area/feature/hokkaido/related/vi_6-32a492ae452e76ec01283f8c1f00cc25.jpg";